module.exports = __webpack_public_path__ + "img/Samurai Panda Esport Logo Template.jpg";